module.exports = __webpack_public_path__ + "static/media/guarapari-es.a2740556.jpg";